







































import {Component, Prop, Vue} from "vue-property-decorator";
import ProductReview from "@/api/ProductReview";
import ReviewSummaryView from "@/components/Dashboard/Review/ReviewSummaryView.vue";

@Component({
  components: {ReviewSummaryView}
})
export default class BoughtProductView extends Vue {
  @Prop() private boughtProduct!: ProductReview;
}
